import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FormAction} from "@shared/module/forms/model";

@Component({
  selector: 'app-header-main-page',
  templateUrl: './header-main-page.component.html',
  styleUrls: ['./header-main-page.component.scss']
})
export class HeaderMainPageComponent implements OnChanges {
  @Input() name!: string;
  @Input() picture?: string | null;
  @Input() entity!: string;
  @Input() formAction: FormAction = FormAction.ADD;
  @Input() loading: boolean = false;
  @Input() saveEnabled: boolean = true;
  @Output() onClick = new EventEmitter<void>();
  public readonly FormAction = FormAction;
  saveConfirm = {
    titleMessage: {
      label:  'common.add-confirmation.title'
    },
    confirmMessage: {
      label: 'common.add-confirmation.confirm'
    }
  };

  ngOnChanges(_: SimpleChanges): void {
    const adding = this.formAction == FormAction.ADD;
    this.saveConfirm = {
      titleMessage: {
        label: adding ? 'common.add-confirmation.title' : 'common.update-confirmation.title'
      },
      confirmMessage: {
        label: adding ? 'common.add-confirmation.confirm' : 'common.update-confirmation.confirm'
      }
    };
  }
}
